<template>
  <el-table-column
    prop="email"
    sortable="custom"
    label="E-mail"
    show-overflow-tooltip
    fixed
    min-width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.email }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'email',
  };
</script>
